export const Services = {
  CONTENT: 'content',
  VIEWS: 'views',
  MEDIA: 'media',
  PERSONALIZATION: 'personalization',
  SEARCH: 'search',
  LISTS: 'lists',
  LISTS_V2: 'listsV2',
  ACCOUNTS: 'accounts',
  START: 'start',
  CLIENTS: 'clients',
  API_INFRASTRUCTURE: 'apiinfrastructure',
  UTILITIES: 'utilities',
  CATALOG_CONSUMER: 'catalogconsumer',
  ASSETS: 'assets',
  QR_CODE: 'qr-code',
  SHORT_URL: 'short-url',
  SUPPORT: 'support',
  PLAYNEXT: 'playnext',
  DASHBOARDS: 'dashboards',
  ANALYTICS: 'analytics',
  CHANNEL_MANAGEMENT: 'channelmanagement',
}

export const Audiences = {
  ADMIN: 'admin',
  PUBLIC: 'public',
}

export const ServiceDisplayNamesMap = {
  [Services.CONTENT]: 'Content Service',
  [Services.VIEWS]: 'Views Service',
  [Services.MEDIA]: 'Media Service',
  [Services.PERSONALIZATION]: 'Personalization Service',
  [Services.SEARCH]: 'Search Service',
  [Services.LISTS]: 'Lists Service (Public List, Page, and Content APIs)',
  [Services.LISTS_V2]:
    'Lists Service (V2) (Public List, Page, and Content APIs)',
  [Services.ACCOUNTS]: 'Accounts Service',
  [Services.START]: 'Start Service',
  [Services.CLIENTS]: 'Clients Service',
  [Services.API_INFRASTRUCTURE]: 'API Infrastructure Service',
  [Services.UTILITIES]: 'Utilities Service',
  [Services.CATALOG_CONSUMER]: 'Catalog Consumer Service',
  [Services.ASSETS]: 'Assets Service',
  [Services.QR_CODE]: 'QR Code Service',
  [Services.SHORT_URL]: 'Short URL Service',
  [Services.SUPPORT]: 'Support Service',
  [Services.PLAYNEXT]: 'PlayNext Service',
  [Services.DASHBOARDS]: 'Analytics Dashboards Service',
  [Services.ANALYTICS]: 'Analytics Service',
  [Services.CHANNEL_MANAGEMENT]: 'Channel Management Service',
}

export const Stages = {
  LOCAL: 'local',
  DEV: 'dev',
  STAGE: 'stage',
  PROD: 'prod',
}

export const StageDisplayNamesMap = {
  [Stages.LOCAL]: 'Local',
  [Stages.DEV]: 'Dev',
  [Stages.STAGE]: 'Stage',
  [Stages.PROD]: 'Prod',
}

export const StageDomainNameMap = {
  [Stages.LOCAL]: 'localhost',
  [Stages.DEV]: 'dev-byub.org',
  [Stages.STAGE]: 'stage-byub.org',
  [Stages.PROD]: 'byub.org',
}

export const HostnameStageMap = {
  localhost: Stages.LOCAL,
  'api.dev-byub.org': Stages.DEV,
  'api.stage-byub.org': Stages.STAGE,
  'api.byub.org': Stages.PROD,
}

export const ServiceLocalPort = {
  CONTENT: 3001,
  VIEWS: 3003,
  MEDIA: 3002,
  PERSONALIZATION: 3004,
  SEARCH: 3005,
  LISTS: 3006,
  LISTS_V2: 3006,
  ACCOUNTS: 3007, // ???
  START: 3008, // ???
  CLIENTS: 3009, // ???
  API_INFRASTRUCTURE: 3009,
  UTILITIES: 3011, // ???
  CATALOG_CONSUMER: 3007, // ???
  ASSETS: 3013, // ???
  QR_CODE: 3014, // ???
  SHORT_URL: 3015, // ???
  SUPPORT: 3016, // ???
  PLAYNEXT: 3017, // ???
  DASHBOARDS: 3018, // ???
  ANALYTICS: 8080, // ???
  CHANNEL_MANAGEMENT: 3010, // ???
}

export const ServiceLocalPortMap = {
  [Services.CONTENT]: ServiceLocalPort.CONTENT,
  [Services.VIEWS]: ServiceLocalPort.VIEWS,
  [Services.MEDIA]: ServiceLocalPort.MEDIA,
  [Services.PERSONALIZATION]: ServiceLocalPort.PERSONALIZATION,
  [Services.SEARCH]: ServiceLocalPort.SEARCH,
  [Services.LISTS]: ServiceLocalPort.LISTS,
  [Services.LISTS_V2]: ServiceLocalPort.LISTS_V2,
  [Services.ACCOUNTS]: ServiceLocalPort.ACCOUNTS,
  [Services.START]: ServiceLocalPort.START,
  [Services.CLIENTS]: ServiceLocalPort.CLIENTS,
  [Services.API_INFRASTRUCTURE]: ServiceLocalPort.API_INFRASTRUCTURE,
  [Services.UTILITIES]: ServiceLocalPort.UTILITIES,
  [Services.CATALOG_CONSUMER]: ServiceLocalPort.CATALOG_CONSUMER,
  [Services.ASSETS]: ServiceLocalPort.ASSETS,
  [Services.QR_CODE]: ServiceLocalPort.QR_CODE,
  [Services.SHORT_URL]: ServiceLocalPort.SHORT_URL,
  [Services.SUPPORT]: ServiceLocalPort.SUPPORT,
  [Services.PLAYNEXT]: ServiceLocalPort.PLAYNEXT,
  [Services.DASHBOARDS]: ServiceLocalPort.DASHBOARDS,
  [Services.ANALYTICS]: ServiceLocalPort.ANALYTICS,
  [Services.CHANNEL_MANAGEMENT]: ServiceLocalPort.CHANNEL_MANAGEMENT,
}

export const ServiceBasePathMap = {
  [Services.CONTENT]: 'content/v1',
  [Services.VIEWS]: 'views/v1',
  [Services.MEDIA]: 'media/v1',
  [Services.PERSONALIZATION]: 'personalization/v1',
  [Services.SEARCH]: 'search/v1',
  [Services.LISTS]: 'views/v1',
  [Services.LISTS_V2]: 'views/v2',
  [Services.ACCOUNTS]: 'v1',
  [Services.START]: '',
  [Services.CLIENTS]: 'clients/v1',
  [Services.API_INFRASTRUCTURE]: 'apiinfrastructure/v1',
  [Services.UTILITIES]: 'utilities/v1', // ???
  [Services.CATALOG_CONSUMER]: 'catalogconsumer/v1', // ???
  [Services.ASSETS]: 'v1',
  [Services.QR_CODE]: 'v1', // ???
  [Services.SHORT_URL]: 'v1', // ???
  [Services.SUPPORT]: 'v1', // ???
  [Services.PLAYNEXT]: 'v1', // ???
  [Services.DASHBOARDS]: 'dashboards/v1',
  [Services.ANALYTICS]: 'analytics/v1',
  [Services.CHANNEL_MANAGEMENT]: 'channelmanagement/v1',
}

export const ServiceSubdomainMap = {
  [Services.CONTENT]: {
    [Audiences.ADMIN]: 'content-api-v1',
  },
  [Services.VIEWS]: {
    [Audiences.ADMIN]: 'views-api-v1',
    [Audiences.PUBLIC]: 'views-api-v1',
  },
  [Services.MEDIA]: {
    [Audiences.ADMIN]: 'media-api-v1',
    [Audiences.PUBLIC]: 'media-api-v1',
  },
  [Services.PERSONALIZATION]: {
    [Audiences.ADMIN]: 'personalization-api',
    [Audiences.PUBLIC]: 'personalization-api',
  },
  [Services.SEARCH]: {
    [Audiences.ADMIN]: 'search-api-v1',
    [Audiences.PUBLIC]: 'search-api-v1',
  },
  [Services.LISTS]: {
    [Audiences.PUBLIC]: 'lists-api-v1-public',
  },
  [Services.LISTS_V2]: {
    [Audiences.PUBLIC]: 'lists-api-v1-public',
  },
  [Services.ACCOUNTS]: {
    [Audiences.ADMIN]: 'accounts-api',
    [Audiences.PUBLIC]: 'accounts-api',
  },
  [Services.START]: {
    [Audiences.ADMIN]: 'start',
    [Audiences.PUBLIC]: 'start',
  },
  [Services.CLIENTS]: {
    [Audiences.ADMIN]: 'clients-api-v1',
    [Audiences.PUBLIC]: 'clients-api-v1',
  },
  [Services.API_INFRASTRUCTURE]: {
    [Audiences.ADMIN]: 'apiinfrastructure-api-v1',
    [Audiences.PUBLIC]: 'apiinfrastructure-api-v1',
  },
  [Services.UTILITIES]: {
    [Audiences.PUBLIC]: 'utilities-api-v1',
  },
  [Services.CATALOG_CONSUMER]: {
    [Audiences.ADMIN]: 'catalogconsumer-api-v1',
  },
  [Services.ASSETS]: {
    [Audiences.ADMIN]: 'assets-api-v1',
    [Audiences.PUBLIC]: 'assets-api-v1',
  },
  [Services.QR_CODE]: {
    [Audiences.PUBLIC]: 'qr',
  },
  [Services.SHORT_URL]: {
    [Audiences.PUBLIC]: 'shorturl-api',
    [Audiences.ADMIN]: 'shorturl-api',
  },
  [Services.SUPPORT]: {
    [Audiences.ADMIN]: 'support-api-v1',
  },
  [Services.PLAYNEXT]: {
    [Audiences.ADMIN]: 'playnext-api', // ???
    [Audiences.PUBLIC]: 'playnext-api',
  },
  [Services.DASHBOARDS]: {
    [Audiences.ADMIN]: 'dashboards-api-v1-admin',
  },
  [Services.ANALYTICS]: {
    [Audiences.PUBLIC]: 'analytics-api-v1-public',
  },
  [Services.CHANNEL_MANAGEMENT]: {
    [Audiences.ADMIN]: 'channelmanagement-api-v1-admin',
  },
}

export const AudienceOptionsMap = {
  [Services.CONTENT]: [Audiences.ADMIN],
  [Services.VIEWS]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.MEDIA]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.PERSONALIZATION]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.SEARCH]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.LISTS]: [Audiences.PUBLIC],
  [Services.LISTS_V2]: [Audiences.PUBLIC],
  [Services.ACCOUNTS]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.START]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.CLIENTS]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.API_INFRASTRUCTURE]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.UTILITIES]: [Audiences.PUBLIC],
  [Services.CATALOG_CONSUMER]: [Audiences.ADMIN],
  [Services.ASSETS]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.QR_CODE]: [Audiences.PUBLIC],
  [Services.SHORT_URL]: [Audiences.PUBLIC, Audiences.ADMIN],
  [Services.SUPPORT]: [Audiences.ADMIN],
  [Services.PLAYNEXT]: [Audiences.ADMIN, Audiences.PUBLIC],
  [Services.DASHBOARDS]: [Audiences.ADMIN],
  [Services.ANALYTICS]: [Audiences.PUBLIC],
  [Services.CHANNEL_MANAGEMENT]: [Audiences.ADMIN],
}

export const LoginUrls = {
  STAGE: 'https://tools-stage.byub.org/api/login',
  PROD: 'https://tools.byub.org/api/login',
}

export const LoginUrlsStageMap = {
  [LoginUrls.PROD]: Stages.PROD,
  [LoginUrls.STAGE]: Stages.STAGE,
}

export const StageAuthRetrievalUrlsMap = {
  [Stages.LOCAL]: 'http://localhost:3001/v1/admin/apidocs/login',
  [Stages.DEV]:
    'https://apiinfrastructure-api-v1.dev-byub.org/apiinfrastructure/v1/admin/apidocs/login',
  [Stages.STAGE]:
    'https://apiinfrastructure-api-v1.stage-byub.org/apiinfrastructure/v1/admin/apidocs/login',
  [Stages.PROD]:
    'https://apiinfrastructure-api-v1.byub.org/apiinfrastructure/v1/admin/apidocs/login',
}
